// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"cf1de5bf","535":"124e5507","760":"6ed85829","877":"d31ee77b"}[chunkId] + ".css";
};